import { useState, useEffect } from "react";
import ReactGA from 'react-ga4';
import { Tabs, Tab } from "@mui/material";
import { TabPanel, TabContext } from "@mui/lab";
import Help from "./components/Help";
import ReleaseNotes from "./components/ReleaseNotes";

const Suppport = () => {
  const [value, setValue] = useState("1");

    useEffect(() => {
      ReactGA.send({
        hitType: "pageview",
        page: "/help",
        title: "Help",
      });
    }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div style={{width: '100%'}}>
      <TabContext value={value}>
        <Tabs
          value={value}
          onChange={handleChange}
          centered
        >
          <Tab label="Help" value="1" />
          <Tab label="Release Notes" value="2" />
        </Tabs>
        <TabPanel value="1" index={0}>
          {/* <AllEvents user={user} /> */}
          <Help />
        </TabPanel>
        <TabPanel value="2" index={1}>
          <ReleaseNotes />
        </TabPanel>
      </TabContext>
    </div>
  );
};

export default Suppport;
